import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { JalurJenis, Periode } from "@/types";
import SkeletonTable from "@/components/SkeletonTable";
import { getListJalurJenis, getListPeriode } from "@/services/getData";
import { useTahun } from "@/hooks/useTahun";

export interface PeriodeResponse {
  data: Periode[];
}

export default function SettingPeriodeOperatorStudentExchangePage() {
  const { selectedTahun } = useTahun();

  const { data: listJalurJenis } = useQuery({
    queryKey: ["listJalurJenis"],
    queryFn: getListJalurJenis,
  });

  const jalurStudentExchange =
    listJalurJenis &&
    listJalurJenis.find(
      (jalur: JalurJenis) => jalur.nama_jalur_jenis_slug == "studentexchange",
    );

  const { data, isPending } = useQuery({
    queryKey: [
      "listPeriodeStudentExchange",
      selectedTahun?.label,
      jalurStudentExchange?.id_ref_jalur_jenis,
    ],
    queryFn: () =>
      getListPeriode(
        selectedTahun?.label,
        jalurStudentExchange?.id_ref_jalur_jenis,
      ),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
